
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#fff","stroke-width":"3","fill":"none"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","stroke":"none"}}),_c('circle',{attrs:{"cx":"16","cy":"16","r":"14.5"}})]),_c('path',{attrs:{"d":"M7 6h19v19H7z","fill":"none"}}),_c('text',{attrs:{"transform":"translate(14 22)","fill":"#fff","font-size":"16","font-family":"Menco-Bold,Menco","font-weight":"700","letter-spacing":".02em"}},[_c('tspan',{attrs:{"x":"0","y":"0"}},[_v('!')])])])
          )
        }
      }
    